import { CustomButton } from "@/components/ui/Buttons";
import Modal from "@/components/ui/Modal";
import AssignmentSubmissionModal from "@/pages/assignmentSubmission/AssignmentSubmissionModal";
import { useState } from "react";

const AssignmentBanner = () => {
  const [isAssignmentModalOpen, setIsAssignmentModalOpen] = useState(false);

  return (
    <div className="p-4 rounded-xl bg-[#F7FAFF] border border-[#17457D1A] flex justify-between items-center">
      <div className="space-y-2.5">
        <h2 className="text-blue-900 text-lg leading-[22px] tracking-[-1%] font-semibold">
          Complete the Assignment
        </h2>
        <p className="text-sm leading-5 tracking-[-1%] text-gray-700">
          Finish the Task to Begin Your Creative Journey with Us
        </p>
      </div>

      <CustomButton
        onClick={() => setIsAssignmentModalOpen(true)}
        backgroundColor="#17457D"
        color="#FFFFFF"
        fontSize="14px"
        fontWeight="500"
        border="1px solid #C2C2C2"
        borderRadius="100px"
        padding="10px 24px"
        className="leading-5 tracking-[-1%]"
      >
        Get Started
      </CustomButton>

      <Modal
        isOpen={isAssignmentModalOpen}
        setOpen={setIsAssignmentModalOpen}
        padding="32px"
        width="738px"
      >
        <AssignmentSubmissionModal />
      </Modal>
    </div>
  );
};

export default AssignmentBanner;
